import React, {Component} from 'react'
import MergerPage from "./MergerPage"
import "../styles/index.scss"

class MergerPageContainer extends Component {
    render() {
        return (
            <div className="MergerPageContainer">
                <div className='container-fluid min-vh-100 bg-white shadow-sm'>
                    <div className='row'>
                        <div className='col'>
                            <MergerPage/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MergerPageContainer
